module.exports = __webpack_public_path__ + "static/media/logo_art-er.3e4262ad.png";